const ITEMS = [
  "21+ YEARS TRIAL EXPERIENCE",
  "$150M+ RECOVERED FOR CLIENTS",
  "LOS ANGELES HQ · WILSHIRE BLVD",
  "STATE BAR OF CALIFORNIA MEMBER",
  "NO FEE UNLESS WE WIN",
  "24/7 IMMEDIATE CASE EVALUATION",
];

export const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-gold/15 bg-navy-900/60 py-4">
    <div className="marquee-track flex w-max items-center">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-8 font-mono text-xs tracking-[0.25em] text-gold/70 whitespace-nowrap">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/40" />
        </span>
      ))}
    </div>
  </div>
);
